// client/src/routes/admin/audit.tsx — SCR-ADM-005 „Jurnal de audit (platformă)" · ADM-001
// (04 §8.17, §8.19).
//
// Where the audit journal went. `owner` and `accountant` lost `Audit.Read` on the Product
// Owner's ruling of 2026-09-15 (D-1630, D-1632), and this is the screen that reads the trail
// now — across every organization, on the platform connection.
//
// Gated once by `/admin`'s layout route, like its sibling.

import { createFileRoute } from '@tanstack/react-router';

import { PlatformAuditScreen } from '@/features/platform/PlatformAuditScreen';

export const Route = createFileRoute('/admin/audit')({
  component: PlatformAuditScreen,
});
